import React, { useState, Fragment, useRef, useContext, useEffect } from 'react'
import PageHead from '../../Components/PageHead';
import { UserContext } from '../../App';
import { Camelcase, compressImage, convertToBase64, getAllBuildings, getUrlParameter, handleCustomSubmit, HideLoder, LogInSchoolID, LogInUserID, origin, ShowLoder, typewatch, unescapeHtml, YYYYMMDD_HHMM } from '../../JS/Common';
import { ApiGetCall, ApiGetCDNData, ApiPostCall } from '../../JS/Connector';
import { useNavigate } from 'react-router-dom';
import AlertsComp from '../../Components/AlertsComp';
import { DeviceDetailsPopup } from '../../Components/DeviceDetailsPopup';
import UserDetailsPopup from '../../Components/UserDetailsPopup';
import Popup from '../../Components/Popup';
import AlertPopup from '../../Components/AlertPopup';
import { CheckValidation, ValidateFile } from '../../Components/Validations';
import ImagesPopup from '../../Components/ImagesPopup';
import { useSelector } from 'react-redux';
import { hasRoleAccess, RoleEnum } from '../../JS/RoleType';
import useConfig from '../../Hooks/useConfig';
import CustomFields from '../CustomField/CustomFields';

export function CreateTicket() {
  const { student } = useConfig();
  const inputRef = useRef(null);
  const suggestionBoxRef = useRef(null);
  const [utils, setUtils] = useState({
    Alerts: "",
    Loading: false,
    innerload: false
  })
  const [AllData, setAllData] = useState({
    TicketId: "",
    SchoolId: "",
    DeviceID: "",
    TicketNum: "",
    TicketStatus: "",
    BuildingId: "",
    IsTicketCreated: 0,
  })
  const [SendData, setSendData] = useState({
    Notes: "",
    BillableFlag: 0,
    LoanerId: ""
  })
  const [SearchForTicketValue, setSearchForTicketValue] = useState('')
  const [SuggestionBoxArray, setSuggestionBoxArray] = useState([])
  const [selectedItemIndex, setSelectedItemIndex] = useState(-1);
  const [IsAlreadyTicketModal, setIsAlreadyTicketModal] = useState(false);
  const [DeviceIssues, setDeviceIssues] = useState([]);
  const [DevicePopup, setDevicePopup] = useState(false);
  const [UserPopup, setUserPopup] = useState(false);
  const [DeviceDetails, setDeviceDetails] = useState({});
  const [DefaultImage, setDefaultImage] = useState(true);
  const [DeviceIssueErrorMsg, setDeviceIssueErrorMsg] = useState('');
  const [BuildingArray, setBuildingArray] = useState([]);
  const [SearchForLonerValue, setSearchForLonerValue] = useState('');
  const [LonerSuggestionBoxArray, setLonerSuggestionBoxArray] = useState([]);
  const [LonerShowSuggestion, setLonerShowSuggestion] = useState('d-none');
  const [PreviewImage, setPreviewImage] = useState(false);
  const [Images, setImages] = useState([]);
  const [ModelImage, setModelImage] = useState('');
  const [deletedId, setdeletedId] = useState([]);
  const [SendOutRepair, setSendOutRepair] = useState(false);
  const [SelectedIds, setSelectedIds] = useState([]);
  const [IsBuildingChangeModal, setIsBuildingChangeModal] = useState(false);
  const [primaryLocation, setPrimaryLocation] = useState(0)
  const [ImageError, setImageError] = useState('')
  const [AlreadyTicketFlag, setAlreadyTicketFlag] = useState(3);
  const [showReworkPopup, setshowReworkPopup] = useState(false);
  const [ReworkFlag, setReworkFlag] = useState(0);
  const [NinetyDaysTickets, setNinetyDaysTickets] = useState([]);
  const [createReworkTicket, setCreateReworkTicket] = useState(null);
  const [selectedReworkTicket, setSelectedReworkTicket] = useState({
    selectedReworkTicketNum: '',
    selectedReworkTicketId: ''
  })
  const [ReworkErrorMsg, setReworkErrorMsg] = useState('');

  const { UserData } = useContext(UserContext);
  const StateData = useSelector((state) => state.authData);
  const adminschoolid = StateData?.AdminSchoolId;
  const DefaultTicketStatus = StateData?.DefaultTicketStatus;
  const navigate = useNavigate();
  const urlDeviceId = getUrlParameter("deviceid")
  const urlTicketId = getUrlParameter("ticketid")
  const [showImagesModal, setShowImagesModal] = useState({
    show: false,
    activeIndex: 0,
    zoomInOut: false,
  });
  const { copyaccesstype, role, copyrole } = UserData;
  const effectiveRole = copyrole || role || null;
  const AdminMenuAccessFlag = hasRoleAccess(effectiveRole, RoleEnum.ALL_ADMINS);

  const [adminCustomFields, setAdminCustomFields] = useState([])
  const [OriginalAdminCustomFields, setAdminOriginalCustomFields] = useState([])
  const [radiorequired, setradiorequired] = useState('')
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!copyaccesstype && AdminMenuAccessFlag) {
      setAllData({ ...AllData, SchoolId: adminschoolid });
    } else {
      setAllData({ ...AllData, SchoolId: LogInSchoolID });
    }
  }, [utils]);

  useEffect(() => {
    GetCustomFieldsData()
  }, [getUrlParameter("ticketid") || AllData.TicketId])

  async function GetCustomFieldsData(id) {

    var Deviceid = getUrlParameter("ticketid") || AllData.TicketId
    Deviceid = Deviceid ? Deviceid : null
    var schoolIdParam = adminschoolid ? adminschoolid : LogInSchoolID;
    await ApiGetCall(`/custom-fields/parent-values-by-id?schoolId=${schoolIdParam}&parentObjectType=2&parentObjectId=${Deviceid}`).then((result) => {
      if (result == undefined || result == "") {
        alert("Something went wrong");
      } else {
        const responseRs = JSON.parse(result);
        // setCustomFields(responseRs?.school_custom_fields)
        // setOriginalCustomFields(responseRs?.school_custom_fields)

        const filteredCustomFields = (AdminMenuAccessFlag || copyaccesstype != null) ? responseRs?.school_custom_fields : responseRs?.school_custom_fields?.filter(field => field.is_system_locked !== 2) || [];

        setAdminCustomFields(filteredCustomFields)
        setAdminOriginalCustomFields(filteredCustomFields)
        // setLoading(false);
      }
    });
  }
  const handleAdminFieldChange = (index, newValue) => {
    const newArray = [...adminCustomFields];
    newArray[index] = { ...newArray[index], value: newValue };
    setAdminCustomFields(newArray);
  };
  useEffect(() => {
    if (DefaultTicketStatus != null) {
      setSendOutRepair(DefaultTicketStatus == 1);
    } else {
      setSendOutRepair(UserData.sendOutForRepairFlag == 1);
    }
  }, [UserData.sendOutForRepairFlag, DefaultTicketStatus])

  useEffect(() => {
    inputRef.current?.focus();
    if (urlTicketId != "" && urlDeviceId != "") {
      setDefaultImage(false);
      setAllData((prevData) => ({
        ...prevData,
        DeviceID: urlDeviceId,
        TicketId: urlTicketId
      }));
      getInventoryDataById(urlDeviceId);
      GetDataForTicket(urlDeviceId, urlTicketId);
    }
    else if (urlDeviceId != "") { //create ticket from manage device
      setDefaultImage(false);
      setAllData((prevData) => ({
        ...prevData,
        DeviceID: urlDeviceId,
      }));
      getInventoryDataById(urlDeviceId);
    }
    GetDeviceIssue();
  }, [AllData?.TicketId])

  useEffect(() => {
    if (AllData.TicketId == '') {
      if (createReworkTicket == 1) {
        if (NinetyDaysTickets?.length !== 0) {
          if (AlreadyTicketFlag == 2) {
            setshowReworkPopup(false);

          } else {
            setshowReworkPopup(true);

          }
        }
      }
    }
  }, [NinetyDaysTickets]);

  //search key down for arrowup, arrowdown and enter
  const handleKeyDown = (e) => {
    setSelectedItemIndex(-1);
    const suggestionCount = SuggestionBoxArray.length;
    let arrowEventStopped = false;
    if (e.key == 'ArrowUp' && selectedItemIndex > 0) {
      e.preventDefault();
      setSelectedItemIndex(selectedItemIndex - 1);
      if (selectedItemIndex === 1) {
        arrowEventStopped = true;
      }
    } else if (e.key == 'ArrowDown' && selectedItemIndex < suggestionCount - 1) {
      e.preventDefault();
      setSelectedItemIndex(selectedItemIndex + 1);
      if (selectedItemIndex === suggestionCount - 2) {
        arrowEventStopped = true;
      }
    } else if (e.key == 'Enter') {
      e.preventDefault();
      const selectedSuggestion = SuggestionBoxArray[selectedItemIndex];
      const suggestionProps = selectedSuggestion.props.children.props;

      // Create a mock event with expected attributes
      const mockEvent = {
        currentTarget: {
          getAttribute: (attr) => suggestionProps[attr] || '',
        },
      };

      setSearchForTicketValue('');
      ShowDeviceDetails(mockEvent);
    }

    if (selectedItemIndex >= 0 && !arrowEventStopped) {
      const suggestionBox = document.querySelector('.SuggestionBoxDiv');
      const suggestionItems = document.querySelectorAll('.suggestion-item');

      if (suggestionBox && suggestionItems.length > 0) {
        const selectedRect = suggestionItems[selectedItemIndex].getBoundingClientRect();
        const suggestionBoxRect = suggestionBox.getBoundingClientRect();

        const isAbove = selectedItemIndex < suggestionCount - 1;
        const isBelow = selectedRect.bottom > suggestionBoxRect.bottom;

        if ((isAbove || isBelow) && selectedItemIndex !== suggestionCount - 1) {
          suggestionBox.scrollTop += selectedRect.top - suggestionBoxRect.top;
        }
      }
    }
  };

  const GetDeviceIssue = () => {
    if (urlTicketId == "" && urlTicketId == false) {
      ApiGetCall("/issues/device/all").then((result) => {
        if (result == undefined || result == "") {
          alert("Something went wrong");
        } else {
          const responseRs = JSON.parse(result);
          setUtils({ ...utils, Loading: false });
          var sugData = responseRs.msg;
          if (responseRs.response == "success") {
            if (sugData.length != 0) {
              setDeviceIssues(sugData)
            } else {
              setDeviceIssues([])
            }
          } else {
            setUtils({ ...utils, Alerts: <AlertsComp show={true} variant="danger" msg={result} /> });
            setTimeout(() => {
              setUtils({ ...utils, Alerts: <AlertsComp show={false} /> });
            }, 2000);
          }
        }
      });
    }
  }

  //store data in suggestion box
  const GetSuggestionBoxData = async (searchstring) => {
    searchstring = searchstring?.trim() == "" ? null : searchstring?.trim();
    setAllData({ ...AllData, TicketId: "" });
    if (searchstring == null) return;
    typewatch(async function () {
      setUtils({ ...utils, innerload: true });
      await ApiGetCall(`/inventory/search-for-ticket?schoolId=${AllData.SchoolId}&search=${searchstring}`).then((result) => {
        if (result == undefined || result == "") {
          alert("Something went wrong");
        } else {
          const responseRs = JSON.parse(result);
          var sugData = responseRs.msg;
          var sugArray = [];
          var i = 1;
          if (sugData.length != 0) {
            for (var i = 0; i < sugData.length; i++) {
              const lastTicketIndex = sugData[i]?.ticket?.length - 1;
              sugArray.push(
                <div key={sugData[i].id} className={`wordwrap brdr-Btm ${sugData[i].isticketcreated == 1 ? 'redText' : ''} `}>
                  <div className='row font-14' onClick={(e) => ShowDeviceDetails(e)} style={{ padding: "0px 15px" }}
                    deviceid={sugData[i].id} isticketcreatedflag={sugData[i].isticketcreated}
                    deviceticketid={sugData[i]?.ticket[lastTicketIndex]?.id}
                    ticketstatusname={sugData[i]?.ticket[lastTicketIndex]?.ticket_status_name}
                    ticketnum={sugData[i]?.ticket[lastTicketIndex]?.ticket_num}
                    ticketstatus={sugData[i]?.ticket[lastTicketIndex]?.ticket_status}>
                    <div className='col-12 d-flex justify-content-between'>
                      <div>Serial #: <b>{sugData[i].serial_number}</b></div>
                      <div>Asset Tag: <b>{sugData[i].asset_tag || '-'}</b></div>
                    </div>
                    {sugData[i]?.student_inventory?.student && (
                      <div className='col-12 d-flex justify-content-between'>
                        <div>{student} #: <b>{sugData[i]?.student_inventory?.student?.student_num || '-'}</b></div>
                        <div >{sugData[i]?.student_inventory?.student?.device_user_first_name && (Camelcase(sugData[i]?.student_inventory?.student?.device_user_first_name))} {sugData[i]?.student_inventory?.student?.device_user_middle_name && (Camelcase(sugData[i]?.student_inventory?.student?.device_user_middle_name))}  {sugData[i]?.student_inventory?.student?.device_user_last_name && (Camelcase(sugData[i]?.student_inventory?.student?.device_user_last_name))}</div>
                      </div>
                    )}
                  </div>
                </div>
              )
            }
            setUtils({ ...utils, innerload: false })
            setSuggestionBoxArray(sugArray)
          } else {
            sugArray.push(
              <>
                <div className="col-12 text-center" key={i}>
                  <label>No Record Found</label>
                </div>
                <div className="col-12 d-flex align-items-center justify-content-center position-absolute pb-2"
                  style={{ bottom: "0", borderTop: "1px solid #e1dddd" }} onClick={(e) => navigate("/addupdate-device")}>
                  <label className='cursor-pointer'>
                    <img src="/images/AddInventory.svg" className="img-fluid pe-2" />
                    <b className="font-18 BlackFont pt-1">Add New Device from Add Inventory</b>
                  </label>
                </div>
              </>
            );
            setUtils({ ...utils, innerload: false })
            setSuggestionBoxArray(sugArray)
          }
        }
      });
    }, 1000);
  }

  //click of device from suggestion box
  const ShowDeviceDetails = (e) => {
    var deviceid = e.currentTarget.getAttribute('deviceid') || '';
    var isticketcreatedflag = e.currentTarget.getAttribute('isticketcreatedflag') || 0;
    var deviceticketid = e.currentTarget.getAttribute('deviceticketid') || '';
    var ticketstatusname = e.currentTarget.getAttribute('ticketstatusname') || '';
    var ticketnum = e.currentTarget.getAttribute('ticketnum') || '';
    var ticketstatus = e.currentTarget.getAttribute('ticketstatus') || '';
    if (ticketstatus == 2 || ticketstatus == 7 || ticketstatus == 8 || ticketstatus == 18) {
      deviceticketid = "";
    }
    setSearchForTicketValue('')
    setAllData((prevData) => ({
      ...prevData,
      DeviceID: deviceid,
      TicketId: deviceticketid,
      TicketNum: ticketnum,
      TicketStatus: ticketstatusname,
      IsTicketCreated: isticketcreatedflag
    }));
    if (isticketcreatedflag == 1) {
      setDefaultImage(true);
      setIsAlreadyTicketModal(true)
    } else {
      setDefaultImage(false);
    }
    const resetFlags = DeviceIssues?.map(item => ({ ...item, flag: 0 }));
    setDeviceIssues(resetFlags);
    setImages([]);
    setSelectedIds([]);
    setDeviceIssueErrorMsg('');
    setSendData(prev => ({ ...prev, Notes: "", BillableFlag: 0 }));
    setAllData(prev => ({ ...prev, BuildingId: "" }));
    setReworkFlag(0);
    setAlreadyTicketFlag(3);
    getInventoryDataById(deviceid)
  }

  //get device data
  const getInventoryDataById = async (deviceid) => {
    setLoading(true);
    await ApiGetCall(`/inventory/by-id?uuid=${deviceid}`).then((result) => {
      if (result == undefined || result == "") {
        alert("Something went wrong");
        setLoading(false);
      } else {
        setLoading(false);
        const responseRs = JSON.parse(result);
        var sugData = responseRs.msg;
        const lastTicketIndex = sugData?.ticket?.length - 1;
        var buildingid = sugData?.ticket[lastTicketIndex]?.return_location_id;
        var ticketNum = sugData?.ticket[lastTicketIndex]?.ticket_num;
        setDeviceDetails(sugData);
        setNinetyDaysTickets(responseRs.last90_days_tickets_details);
        setCreateReworkTicket(responseRs.create_rework_ticket);
        setAllData((prevData) => ({
          ...prevData,
          BuildingId: buildingid ? buildingid : sugData.building_id,
          DeviceID: sugData.id,
          TicketNum: ticketNum
        }));
        getAllBuildings(setBuildingArray, sugData.school_id);
      }
    });
  }

  //key down handle for loner device search
  const handleKeyDownForLoner = (event) => {
    const searchValue = event.target.value.trim();
    if (searchValue !== "" && (event.key == "Enter" || event.keyCode == 13)) {
      event.preventDefault();
      getLonerDevices(searchValue)
    }
    return false;
  }

  //search loaner devices
  const getLonerDevices = async (searchvalue) => {
    setUtils({ ...utils, innerload: true });
    setLonerShowSuggestion("");
    searchvalue = searchvalue?.trim() == "" ? null : searchvalue?.trim();
    typewatch(async function () {
      await ApiGetCall(`/tickets/search-loaner?schoolId=${AllData.SchoolId}&search=${searchvalue}`).then((result) => {
        if (result == undefined || result == "") {
          alert("Something went wrong");
        } else {
          const responseRs = JSON.parse(result);
          setUtils({ ...utils, innerload: false });
          var sugData = responseRs.msg;
          var sugArray = [];
          var i = 1;
          if (Array.isArray(sugData) && sugData.length != 0) {
            for (var i = 0; i < sugData.length; i++) {
              sugArray.push(
                <div className="col-md-12 d-flex justify-content-between brdr-Btm font-14" key={i} onClick={(e) => SetLoanerData(e)}
                  loanerid={sugData[i].id} studentname={sugData[i].serial_number}>
                  <div style={{ padding: '8px 15px' }}>Serial : {sugData[i].serial_number} / Asset: {sugData[i]?.asset_tag || '-'}</div>
                </div>
              )
            }
            setLonerSuggestionBoxArray(sugArray)
          } else {
            sugArray.push(
              <>
                <div className="col-12 text-center" key={i}>
                  <label>No Record Found</label>
                </div>
              </>
            );
            setLonerSuggestionBoxArray(sugArray)
          }

        }
      });
    }, 1000);
  }

  // set loaner data in input box
  const SetLoanerData = (e) => {
    var loanerid = e.currentTarget.getAttribute('loanerid') || '';
    var studentname = e.currentTarget.getAttribute('studentname') || '';
    setSendData({ ...SendData, LoanerId: loanerid });
    setLonerShowSuggestion('d-none');
    setSearchForLonerValue(studentname);
  }

  const handleFileUpload = async (e) => {
    let errorMsgs = [];
    const file = Array.from(e.target.files);
    const validImages = await Promise.all(
      file.map(async (image) => {
        if (!image) return null;
        const { isFileValid, validationMsg } = ValidateFile(image, { allowedType: "image", maxSizeMB: 2 });
        if (!isFileValid) {
          errorMsgs.push(validationMsg);
          return null;
        }
        const compressedImg = await compressImage(image);
        const base64 = await convertToBase64(compressedImg);
        return { img: base64, id: 0, name: image.name };
      })
    );
    setImages((prev) =>
      [...prev, ...validImages].filter(Boolean).filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.name === item.name || t.img === item.img)
      )
    );
    setImageError(errorMsgs.length > 0 ? errorMsgs[0] : "");
    e.target.value = "";
  };

  //delete image
  async function DeleteImage(i, id) {
    setImages(Images.filter((data, j) => j !== i));
    if (id != 0) {
      let ob = new Object();
      ob.id = id;
      setdeletedId(prev => [...prev, ob])
    }

  }

  //device issue checkbox handle
  const handleDeviceIssueChange = (event, item) => {
    const isChecked = event.target.checked;
    const FlagForEdit = AllData.TicketId ? 2 : 1;
    const updatedItems = DeviceIssues.map((i) => {
      if (i.id == item.id) {
        return { ...i, flag: isChecked ? (FlagForEdit != 2 ? 1 : 1) : (FlagForEdit != 2 ? 0 : 3) };
      }
      return i;
    });
    setDeviceIssues(updatedItems);

    if (FlagForEdit !== 2) {
      const selectedItems = updatedItems.filter((i) => i.flag === 1);
      const selectedIDs = selectedItems.map((i) => ({ IssueID: i.id }));
      setSelectedIds(selectedIDs);
    } else {
      const filteredData = updatedItems
        .filter((i) => i.flag === 1 || i.flag === 3)
        .map((i) => ({ IssueID: i.id, flag: i.flag }));
      setSelectedIds(filteredData);
    }
  }

  //change for building
  const handleChangeForBuilding = (e) => {
    const selectedBuildingID = e.target.value;
    setAllData((prevData) => ({
      ...prevData,
      BuildingId: selectedBuildingID,
    }));
    if (selectedBuildingID !== '0') {
      setIsBuildingChangeModal(true);
    } else {
      setIsBuildingChangeModal(false);
    }
  }

  //final save for create ticket
  const createTicketCall = async (flag) => {
    var isFormValid = CheckValidation({ formID: "TicketForm" });
    let adminCustomFieldValues = handleCustomSubmit(adminCustomFields, OriginalAdminCustomFields, 1);
    if (adminCustomFields.length > 0) {
      let tempErrors = {};

      adminCustomFields.forEach((item, index) => {
        if ((item.value_type == 6 || item.value_type == 7) && item.is_required == 1) {
          if (item.value_type == 6 ? item.value == null : item.value.length == 0) {
            tempErrors[item.id] = "*required";
            isFormValid = false;
          }
        }
      });

      setradiorequired(tempErrors);

    }
    if (!isFormValid) return;
    if (SelectedIds == '') {
      setDeviceIssueErrorMsg('*required');
      return;
    }
    setDeviceIssueErrorMsg('');
    setUtils({ ...utils, Loading: true });
    var lonerDeviceStatus = 0;



    var NewJson = {};
    NewJson['billableFlag'] = SendData.BillableFlag;
    NewJson['notes'] = SendData.Notes;
    NewJson['schoolId'] = AllData.SchoolId;
    NewJson['userId'] = LogInUserID;
    NewJson['inventoryId'] = DeviceDetails.id;
    NewJson['selectedBuidingId'] = AllData.BuildingId == 0 || AllData.BuildingId == undefined ? null : AllData.BuildingId;
    if (DeviceDetails.student != null) {
      lonerDeviceStatus = 1;
      NewJson['loanerId'] = SendData.LoanerId;
      NewJson['loanerDeviceStatus'] = lonerDeviceStatus;
    } else {
      lonerDeviceStatus = 0;
      NewJson['loanerId'] = null;
      NewJson['loanerDeviceStatus'] = lonerDeviceStatus;
    }
    var raw = JSON.stringify({
      deviceIssues: SelectedIds,
      messages: NewJson,
      images: Images,
      primaryLocationFlag: primaryLocation,
      sendOutForTicket: SendOutRepair == true ? 1 : 0,
      ticketNumber: ReworkFlag == 1 ? selectedReworkTicket?.selectedReworkTicketNum : null,
      ticketId: ReworkFlag == 1 ? selectedReworkTicket?.selectedReworkTicketId : null,
      reworkFlag: ReworkFlag,
      customFieldValues: adminCustomFieldValues,
      parentObjectType: 2,
      parentObjectID: 0,
    });
    await ApiPostCall("/tickets/save", raw).then((result) => {
      if (result == undefined || result == "") {
        alert("Something went wrong");
      } else {
        const responseRs = JSON.parse(result);
        if (responseRs.response == "success") {
          setUtils({ ...utils, Loading: false })
          if (flag == 2) { //create ticket & next
            setImages([]);
            setSendData({ ...SendData, Notes: "", BillableFlag: 0, LoanerId: "" })
            setAllData({ ...AllData, TicketId: "", SchoolId: "", DeviceID: "", TicketNum: "", TicketStatus: "", BuildingId: "", IsTicketCreated: 0 })
            setDefaultImage(true);
            setSelectedIds([]);
            setPrimaryLocation(0)
            const resetFlags = DeviceIssues?.map(item => ({ ...item, flag: 0 }));
            setDeviceIssues(resetFlags);
            setReworkFlag(0);
            navigate("/create-ticket", { replace: true })
          } else { //create ticket
            if (AdminMenuAccessFlag) {
              if (copyaccesstype) {
                navigate('/manage-tickets', { state: { ticketid: responseRs.ticketid } })
              } else {
                navigate('/school-tickets', { state: { ticketid: responseRs.ticketid } })
              }
            } else {
              navigate('/manage-tickets', { state: { ticketid: responseRs.ticketid } })
            }
          }
        } else {
          setUtils({ ...utils, Alerts: <AlertsComp show={true} variant="danger" msg={responseRs.msg} /> })
          setTimeout(() => {
            setUtils({ ...utils, Alerts: <AlertsComp show={false} />, Loading: false })
          }, 2500);
        }
      }
    })

    if (flag == 2) {
      inputRef?.current?.focus();
    }
  }

  //update ticket call
  const UpdateTicketCall = async () => {
    var isFormValid = CheckValidation({ formID: "TicketForm" });
    let adminCustomFieldValues = handleCustomSubmit(adminCustomFields, OriginalAdminCustomFields, 1);
    if (adminCustomFields.length > 0) {
      let tempErrors = {};

      adminCustomFields.forEach((item, index) => {
        if ((item.value_type == 6 || item.value_type == 7) && item.is_required == 1) {
          if (item.value_type == 6 ? item.value == null : item.value.length == 0) {
            tempErrors[item.id] = "*required";
            isFormValid = false;
          }
        }
      });

      setradiorequired(tempErrors);

    }
    if (!isFormValid) return;
    const hasSelectedItems = SelectedIds.some(item => item.flag == 1);
    if (!hasSelectedItems) {
      setDeviceIssueErrorMsg('*required');
      return;
    }
    setDeviceIssueErrorMsg('')
    setUtils((prevdata) => ({ ...prevdata, Loading: true }));
    if (SendData.LoanerId != '') {
      var LonerStatus = 1;
    } else {
      var LonerStatus = 0;
    }

    var raw = JSON.stringify({
      schoolId: AllData.SchoolId,
      userId: LogInUserID,
      ticketId: AllData.TicketId,
      inventoryId: AllData.DeviceID,
      notes: SendData.Notes,
      issue: SelectedIds,
      isLoaner: LonerStatus,
      assignLoanerId: SendData.LoanerId,
      images: Images,
      deleteImgs: deletedId,
      selectedBuidingId: AllData.BuildingId,
      primaryLocationFlag: primaryLocation,
      chargeability: SendData.BillableFlag,
      customFieldValues: adminCustomFieldValues,
      parentObjectType: 2,
      parentObjectID: 0,
    });
    await ApiPostCall("/tickets/edit", raw).then((result) => {
      if (result == undefined || result == "") {
        alert("Something went wrong");
      } else {
        const responseRs = JSON.parse(result);
        if (responseRs.response == "success") {
          setUtils((prevdata) => ({ ...prevdata, Loading: false, Alerts: <AlertsComp show={true} variant="success" msg={'Ticket Updated Successfully'} /> }));
          setTimeout(function () {
            setUtils((prevdata) => ({ ...prevdata, Alerts: <AlertsComp show={false} /> }));
            if (!copyaccesstype && AdminMenuAccessFlag) {
              navigate('/school-tickets')
            } else {
              navigate('/manage-tickets')
            }
          }, 1500);
        } else {
          setUtils((prevdata) => ({ ...prevdata, Loading: false, Alerts: <AlertsComp show={true} variant="danger" msg={result} /> }));
          setTimeout(() => {
            setUtils((prevdata) => ({ ...prevdata, Loading: false, Alerts: <AlertsComp show={false} /> }));
          }, 2000);
        }
      }
    });
  }



  //again create ticket on repair billed status
  async function AgainCreateTicketCall(deviceid, ticketid, flag) {
    setUtils((prevdata) => ({ ...prevdata, Loading: true }));
    var raw = JSON.stringify({
      schoolId: AllData.SchoolId,
      userId: LogInUserID,
      ticketId: ticketid,
      inventoryId: deviceid,
    });
    await ApiPostCall("/tickets/change-to-closed", raw).then((result) => {
      if (result == undefined || result == "") {
        alert("Something went wrong");
      } else {
        const responseRs = result;
        if (responseRs == "success") {
          if (flag == 1) {
            setAllData((prevdata) => ({ ...prevdata, TicketId: "" }));
          } else {
            setUtils({ ...utils, Loading: false, Alerts: <AlertsComp show={true} variant="success" msg={'Ticket Closed Successfully'} /> })
          }
          setTimeout(function () {
            setUtils({ ...utils, Alerts: <AlertsComp show={false} /> })
            setIsAlreadyTicketModal(false)
            setDefaultImage(false)
            getInventoryDataById(AllData.DeviceID)
          }, 1500);
        } else {
          setUtils({ ...utils, Loading: false, Alerts: <AlertsComp show={true} variant="danger" msg={result} /> })
          setTimeout(() => {
            setUtils({ ...utils, Alerts: <AlertsComp show={false} /> })
          }, 2000);
        }
      }
    });
  }

  const GetDataForTicket = async (deviceid, ticketid) => {
    await ApiGetCall(`/tickets/data?ticketId=${ticketid}&inventoryId=${deviceid}`).then((result) => {
      if (result == undefined || result == "") {
        alert("Something went wrong");
      } else {
        const responseRs = JSON.parse(result);
        var historyDataForNotes = responseRs.msg;
        var FlagForEditTicketIssue = responseRs.issues;
        var AssignLonerData = responseRs.loaner
        var imagesData = responseRs.images
        setIsAlreadyTicketModal(false);
        setAlreadyTicketFlag(3)
        if (responseRs.response == "success") {
          setDefaultImage(false)
          getInventoryDataById(deviceid)
          setSendData((prevData) => ({
            ...prevData, Notes: historyDataForNotes.notes, BillableFlag: historyDataForNotes?.chargeability
          }))
          if (FlagForEditTicketIssue.length != 0) {
            setDeviceIssues(FlagForEditTicketIssue)
          }
          if (AssignLonerData != '') {
            setSearchForLonerValue(AssignLonerData)
          }
          if (imagesData?.length > 0) {
            Promise.all(
              imagesData.map((picture) =>
                ApiGetCDNData("/" + picture.img, StateData?.Schoolnumber).then((blob) => ({
                  id: picture.id,
                  img: blob && URL.createObjectURL(blob)
                }))
              )
            ).then((urls) => {
              setImages(urls);
            });
          }
          const defaultSelectedItems = FlagForEditTicketIssue.filter((i) => i.flag == 1);
          const defaultSelectedIDs = defaultSelectedItems.map((i) => ({ IssueID: i.id, flag: i.flag }));
          setSelectedIds(defaultSelectedIDs)
        } else {
          setUtils({ ...utils, Alerts: <AlertsComp show={true} variant="danger" msg={result} /> })
          setTimeout(() => {
            setUtils({ ...utils, Alerts: <AlertsComp show={false} /> })
          }, 2000);
        }
      }
    });
  }

  //rework modal body
  const ReworkModalBody = (
    <>
      <p>Is this issue a repeat of the following previous tickets due to part failure or incomplete repair?</p>
      {NinetyDaysTickets?.map((ticket, index) => (
        <div className="d-flex py-1" key={index}>
          <input
            className="form-check-input"
            type="radio"
            name="reworkFlag"
            onChange={() => { setSelectedReworkTicket({ ...selectedReworkTicket, selectedReworkTicketId: ticket?.ticket_id, selectedReworkTicketNum: ticket?.ticket_number }) }}
            checked={selectedReworkTicket?.selectedReworkTicketNum == ticket?.ticket_number}
          />
          <label className='ps-3'>
            Ticket Number <b>{ticket?.ticket_number}</b> has following issues: <b>{ticket?.issues.length > 1 ? ticket?.issues.join(', ') : ticket?.issues[0]}</b>. Notes: <b>{ticket?.notes}</b>. Its Status is <b>{ticket?.status_name}. </b>
          </label>
        </div>
      ))}
      {ReworkErrorMsg && (
        <div className='redText'>{ReworkErrorMsg}</div>
      )}
    </>
  )
  const ticketmodalbody = (
    <>
      There is currently an open ticket on this device <br />(Ticket Num :{AllData.TicketNum}). The current ticket status of this ticket is {AllData.TicketStatus}.
      {AllData.TicketStatus == 'Repair Billed' || AllData.TicketStatus == 'Repair Finished' ? (
        <div className='col-md-12 mt-3'>
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name='ticket'
              onChange={(e) => setAlreadyTicketFlag(1)}
            />
            <label className="form-check-label">Open New Ticket, Close Current Ticket</label>
          </div>
          <div className="form-check my-1">
            <input
              className="form-check-input"
              type="radio"
              name='ticket'
              onChange={(e) => setAlreadyTicketFlag(0)}
            />
            <label className="form-check-label">Edit Current Ticket</label>
          </div>
          {createReworkTicket == 1 &&
            NinetyDaysTickets.length > 0 && (
              <div className="form-check my-1">
                <input
                  className="form-check-input"
                  type="radio"
                  name='ticket'
                  onChange={(e) => { setAlreadyTicketFlag(2); getInventoryDataById(AllData.DeviceID) }}
                />
                <label className="form-check-label">Rework</label>
              </div>
            )}
        </div>
      ) : null}
      {AlreadyTicketFlag == 2 && (
        <>
          <hr />
          {ReworkModalBody}
        </>
      )}
    </>
  )

  const handleMarkRework = () => {
    if (!selectedReworkTicket?.selectedReworkTicketNum) {
      setReworkErrorMsg('*Please select one ticket');
    }
    else {
      setReworkErrorMsg('');
      setReworkFlag(1);
      setshowReworkPopup(false);
      setIsAlreadyTicketModal(false);
      if (AlreadyTicketFlag == 2) {
        AgainCreateTicketCall(AllData.DeviceID, AllData.TicketId, 1)
      }
    }
  }
  const handleNoRework = () => {
    setReworkErrorMsg('');
    setshowReworkPopup(false);
    setIsAlreadyTicketModal(false);
    setReworkFlag(0);
    if (AlreadyTicketFlag == 2) {
      setDefaultImage(false);
      getInventoryDataById(AllData.DeviceID)
    }
  }
  const showButton = (
    (['Repair Billed', 'Repair Finished'].includes(AllData.TicketStatus) &&
      (AlreadyTicketFlag === 0 || AlreadyTicketFlag === 1))
    || AllData.TicketStatus !== 'Repair Billed' || AllData.TicketStatus !== 'Repair Finished'
  );

  const modalfooter = (
    <>
      {AlreadyTicketFlag == 2 ?
        <>
          <button className="Cancel-btn" onClick={handleNoRework}>
            Not a Rework
          </button>
          <button className="SaveBtn" onClick={handleMarkRework}>
            Mark as Rework
          </button>
        </>
        :
        <>
          <label className="ms-2 cursor-pointer"
            onClick={() => {
              setDefaultImage(true);
              setIsAlreadyTicketModal(false);
              setAllData(prevData => ({ ...prevData, TicketId: "", SchoolId: "", DeviceID: "", TicketNum: "", TicketStatus: "", BuildingId: "", IsTicketCreated: 0 }));
              setAlreadyTicketFlag(3);
            }}>
            <u>Cancel</u>
          </label>
          {showButton && (
            <button
              className="SaveBtn"
              onClick={() => {
                if (AllData.TicketStatus == 'Repair Billed' || AllData.TicketStatus == "Repair Finished") {
                  if (AlreadyTicketFlag == 0) {
                    GetDataForTicket(AllData.DeviceID, AllData.TicketId);
                  } else if (AlreadyTicketFlag == 1) {
                    AgainCreateTicketCall(AllData.DeviceID, AllData.TicketId, 2);
                  }
                } else {
                  GetDataForTicket(AllData.DeviceID, AllData.TicketId);
                }
              }}
            >
              {AllData.TicketStatus == 'Repair Billed' || AllData.TicketStatus == "Repair Finished" ?
                AlreadyTicketFlag == 0 ? 'Edit Ticket' :
                  AlreadyTicketFlag == 1 ? 'Create Ticket' : 'Edit Ticket'
                :
                'Edit Ticket'}
            </button>
          )}
        </>
      }
    </>
  )

  return (
    <Fragment>
      {loading ? <ShowLoder /> : <HideLoder />}
      <PageHead heading={AlreadyTicketFlag == 1 ? 'Create Ticket' : AllData.TicketId == "" ? 'Create Ticket' : 'Edit Ticket'}
        loading={utils.Loading} Alerts={utils.Alerts} showsearch={false} />
      <div className="container-fluid px-0 pt-2">
        <div className="GridBox p-3">

          {/* searchbox */}
          <div className='col-12 row'>
            {AllData.TicketId == "" && (
              <div className='col-md-7 col-12' >
                <form className="gridsearchbar" tabIndex={-1} onSubmit={(e) => e.preventDefault()}
                  onBlur={(e) => {
                    if (!e.currentTarget.contains(e.relatedTarget)) {
                      setSearchForTicketValue('');
                      setSuggestionBoxArray([]);
                    }
                  }}
                >
                  <div className="position-absolute top-50 translate-middle-y search-icon ms-3 searchIcon">
                    <i className="bi bi-search"></i>
                  </div>
                  <input className="form-control" autoComplete="off" type="text" ref={inputRef}
                    placeholder={`Search by Serial #, ${student} #, ${student} Name, Asset Tag`} value={SearchForTicketValue}
                    onChange={(e) => setSearchForTicketValue(e.target.value)} onKeyDown={handleKeyDown}
                    onPaste={(e) => GetSuggestionBoxData(e.target.value)} onKeyUp={(e) => GetSuggestionBoxData(e.target.value)} />
                  <div className={`z-1 SuggestionBoxDiv ${SearchForTicketValue?.trim() ? '' : 'd-none'}`} ref={suggestionBoxRef}>
                    {utils.innerload && (
                      <div className='row'>
                        <div className="col-12 text-center pt-2">
                          <img src="/images/loder.svg" style={{ width: "30px" }} />
                        </div>
                      </div>
                    )}
                    {SuggestionBoxArray.map((suggestion, index) => (
                      <div key={index} className={`suggestion-item ${index == selectedItemIndex ? 'selected' : ''}`}>
                        {suggestion}
                      </div>
                    ))}
                  </div>
                </form>
              </div>
            )}
            <div className='col-md-5'>
              {ReworkFlag == 1 &&
                <div className="col-12 text-end redText">
                  Ticket Number:&nbsp; <b>{selectedReworkTicket?.selectedReworkTicketNum}</b>  &nbsp;is marked as rework.
                </div>
              }
            </div>
          </div>

          {/* default image and main div */}
          {DefaultImage ?
            <div className='text-center py-3'>
              <img src='/images/createTicketImg.svg' className='img-fluid' />
            </div>
            :
            <div className='mt-3'>
              <div className='parent' id="TicketForm">
                {AllData.IsTicketCreated == 1 && (
                  <div className='col-12 text-end font-13 redText'>A ticket has been created on the device</div>
                )}

                <label className='col-12'>
                  <b>Active Coverage: </b> <u className='cursor-pointer' style={{ color: DeviceDetails?.active_coverage_type_color }}>{DeviceDetails.active_coverage_type ?? '-'}</u>
                </label>

                {/* device details */}
                <div className='col-12 greyBox mt-3'>
                  <div className="row">
                    <div className="col-md-6 col-xl-4 col-lg-6 col-12 my-1">
                      Serial #:&nbsp;
                      <span className="fw-600 wordwrap">
                        {DeviceDetails?.serial_number}
                      </span>
                      <img src="/images/InfoIcon.svg" title="Show Device Details" className="img-fluid cursor-pointer px-2" onClick={() => { setDevicePopup(true) }} />
                    </div>
                    <div className="col-md-6 col-xl-4 col-lg-6 col-12 my-1">
                      Asset Tag: &nbsp;
                      <span className="fw-600">
                        {DeviceDetails?.asset_tag || '-'}
                      </span>
                    </div>
                    {DeviceDetails?.student != null && (
                      <div className="col-md-6 col-xl-4 col-lg-6 col-12 my-1">
                        {student} #: &nbsp;
                        <span className="fw-600">
                          {DeviceDetails?.student.student_num}
                        </span>
                        <img src="/images/InfoIcon.svg" title="Show User Details" className="img-fluid cursor-pointer px-2" onClick={(e) => { setUserPopup(true) }} />
                      </div>
                    )}
                    {DeviceDetails?.student != null && (
                      <div className="col-md-6 col-xl-4 col-lg-6 col-12 my-1">
                        Device User Name: &nbsp;
                        <span className="fw-600">
                          {DeviceDetails.student.device_user_first_name &&
                            (Camelcase(DeviceDetails.student.device_user_first_name))} {" "}
                          {DeviceDetails.student.device_user_middle_name &&
                            (Camelcase(DeviceDetails.student.device_user_middle_name))} {" "}
                          {DeviceDetails.student.device_user_last_name &&
                            (Camelcase(DeviceDetails.student.device_user_last_name))}
                        </span>
                      </div>
                    )}
                    <div className="col-md-12 col-xl-8 col-lg-12 col-12 my-1">
                      Notes: &nbsp;
                      <span className="fw-600">
                        {DeviceDetails.notes || '-'}
                      </span>
                    </div>
                  </div>
                </div>

                {/* device issues */}
                <div className='col-12 greyBox mt-4'>
                  <small className='redText fs-11'>*Mandatory</small>
                  <div className='Header'>
                    <b className='font-18'>Device Issues</b><br />
                  </div>
                  <div className="row px-3">
                    {DeviceIssues.map((item, i) => {
                      return (
                        <div className="col-md-3 col-sm-6 pt-2" key={i}>
                          <div className="form-check">
                            <input
                              id={`Device_Issue_${item.id}`}
                              className="form-check-input cursor-pointer"
                              type="checkbox"
                              checked={item.flag == 1}
                              onChange={(event) => handleDeviceIssueChange(event, item)}
                            />
                            <label htmlFor={`Device_Issue_${item.id}`} className="form-check-label ps-1 cursor-pointer">
                              {item.issue}
                            </label>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="px-1 redText">{DeviceIssueErrorMsg}</div>
                  <div className='col-md-6 pt-3'>
                    <textarea placeholder="Notes" rows="1" className="form-control" required
                      value={unescapeHtml(SendData.Notes)} onChange={(e) => setSendData({ ...SendData, Notes: e.target.value })}></textarea>
                    <span className="form-text invalid-feedback">*required</span>
                  </div>
                </div>

                {/* return location, billable and assign a loner */}
                <div className='row mt-4'>
                  {/* return location */}
                  <div className={`${DeviceDetails.student ? 'col-md-4' : 'col-md-6'} px-3 py-1`}>
                    <div className='greyBox h-100'>
                      <div><b>Return Location{DeviceDetails.building_id ? '*' : ''}</b></div>
                      <select required={DeviceDetails.building_id} value={AllData.BuildingId}
                        onChange={(e) => { handleChangeForBuilding(e) }}>
                        <option value="0">Select</option>
                        {BuildingArray.map((item, j) => (
                          <option value={item.id} key={j}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                      {DeviceDetails.building_id && <span className="form-text invalid-feedback"> *required  </span>}
                    </div>
                  </div>

                  {/* billable div */}
                  <div className={`${DeviceDetails.student ? 'col-md-4' : 'col-md-6'} px-3 py-1`}>
                    <div className='greyBox h-100'>
                      <div><b>Would you like to mark this ticket as billable to the {student}?</b></div>
                      <div className='col-md-12 mt-3 d-flex align-items-center'>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name='billable'
                            onChange={(e) => setSendData({ ...SendData, BillableFlag: 1 })}
                            checked={SendData.BillableFlag == 1}
                          />
                          <label className="form-check-label">Yes</label>
                        </div>
                        <div className="form-check ms-5">
                          <input
                            className="form-check-input"
                            type="radio"
                            name='billable'
                            onChange={(e) => setSendData({ ...SendData, BillableFlag: 0 })}
                            checked={SendData.BillableFlag != 1}
                          />
                          <label className="form-check-label">No</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* assign a loaner */}
                  <div className={`${DeviceDetails.student ? 'col-md-4 px-3 py-1' : 'd-none'}`}>
                    <div className='greyBox h-100'>
                      <div><b>Assign a Loaner</b></div>
                      <div className="row align-items-center pt-2">
                        <div className="col-12">
                          <form className="gridsearchbar" onSubmit={(e) => e.preventDefault()}>
                            <div className="position-absolute top-50 translate-middle-y search-icon ms-3 searchIcon"><i className="bi bi-search"></i></div>
                            <input className="form-control" autoComplete="off" type="text" placeholder="Search"
                              value={SearchForLonerValue} onChange={(e) => setSearchForLonerValue(e.target.value)}
                              onKeyDown={handleKeyDownForLoner} onKeyUp={(e) => getLonerDevices(e.target.value)} />
                            <div className={`SuggestionBoxDiv z-1 ${LonerShowSuggestion}`} onMouseLeave={(e) => setLonerShowSuggestion('d-none')}>
                              {utils.innerload ? (
                                <div className='row'>
                                  <div className="col-12 text-center pt-2">
                                    <img src="/images/loder.svg" style={{ width: "30px" }} />
                                  </div>
                                </div>
                              ) : LonerSuggestionBoxArray}
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
                {adminCustomFields.length != 0 &&
                  <div className="col-12 greyBox mt-4">
                    {/*custom field */}
                    <div className="p-2">
                      <div className='row px-2 justify-content-between my2'>
                        <b>Custom Fields</b>
                        {adminCustomFields.map((field, index) => {
                          return (
                            <>
                              <div className='col-md-6 row align-items-center py-1'>
                                <div className='col-md-7 FormLabel'>{field.name.charAt(0).toUpperCase() + field.name.slice(1)} {field.is_required == 1 && <span className="custom-text-danger">*</span>}</div>
                                <div className='col-md-5'>
                                  <CustomFields
                                    key={field.id}
                                    id={field.id}
                                    type={parseInt(field.value_type)}
                                    value={field.value_type == 4 || field.value_type == 5 ? field?.value ? new Date(field?.value) : null : field?.value}
                                    options={field?.customfieldstructures}
                                    isrequired={field.is_required}
                                    disabled={(AdminMenuAccessFlag || copyaccesstype != null) ? false : field?.is_system_locked === 1 ? true : false}
                                    radiorequired={radiorequired}
                                    onChange={(value) => handleAdminFieldChange(index, field.value_type == 4 ? YYYYMMDD_HHMM(value) : field.value_type == 5 ? YYYYMMDD_HHMM(value) : value)}
                                  />
                                  {errors[field.id] && <span className="custom-text-danger">{errors[field.id]}</span>}

                                </div>
                              </div>
                            </>

                          )
                        })}
                      </div>

                    </div>
                  </div>
                }
                {/* attach image */}
                <div className='col-12 greyBox mt-4'>
                  <input type="file" label="Image" name="myFile" accept=".jpg,.png,.jpeg"
                    id="UploadFileId" multiple onChange={(e) => handleFileUpload(e)} />
                  <div className="row">
                    <div className='col-md-4 col-sm-5 col-10 col-lg-4 col-xl-3'>
                      <label className="BorderBtn text-center d-flex align-items-center 
                      justify-content-around fw-600" htmlFor="UploadFileId">Attach Images
                        <label className="attach-img-icon cursor-pointer" htmlFor="UploadFileId"> + </label>
                      </label>
                    </div>
                    <div className={`col-md-12 mt-4 d-flex flex-wrap`} >
                      {Images.length > 0 &&
                        Images.map((data, i) => {
                          return (
                            <div className="col-md-2 col-xl-1 col-lg-2 col-sm-2 col-4 my-3 position-relative mx-2" key={i} style={{ border: '1px solid black' }} >
                              <img className="img-fluid cursor-pointer"
                                src={data?.img} alt=""
                                onClick={() => setShowImagesModal({ ...showImagesModal, show: true, activeIndex: i })}
                                style={{ maxHeight: '100%' }} />
                              <label className="attach-img-close-icon position-absolute" onClick={() => DeleteImage(i, data.id)}>  x </label>
                            </div>
                          )
                        })
                      }
                    </div>
                    <span className='redText'>{ImageError}</span>
                  </div>
                </div>

                {/* mark as send out for repair */}
                {AllData.TicketId == "" && (
                  <div className='d-flex align-items-center justify-content-center pt-3'>
                    <input className='form-check-input mt-0 me-2 cursor-pointer' type="checkbox"
                      checked={SendOutRepair} onChange={(e) => { setSendOutRepair(e.target.checked); }} />
                    <span className='fw-600 ps-3' style={{ fontSize: '17px' }}>
                      Mark as 'Send Out for Repair'</span>
                  </div>
                )}

                {/* save cancel buttons */}
                <div className="col-12 text-center py-3">
                  {AllData.TicketId == '' || AlreadyTicketFlag == 1 ?
                    <>
                      <button className='SaveBtn align-items-center mx-2' onClick={() => createTicketCall(2)}>
                        <span className='pt-2 fw-600'>Create Ticket & Next</span>
                        <img src='/images/DoneIcon.svg' className='img-fluid' style={{ height: '22px', width: '25px' }} />
                      </button>
                      <button className='SaveBtn align-items-center' onClick={() => createTicketCall(1)}>
                        <span className='pt-2 fw-600'>Create Ticket</span>
                        <img src='/images/DoneIcon.svg' className='img-fluid' style={{ height: '22px', width: '25px' }} />
                      </button>
                      <button className={`Cancel-btn ms-2`} onClick={(e) => !copyaccesstype && AdminMenuAccessFlag ? navigate('/school-tickets') : navigate('/manage-tickets')}>
                        <span className='pt-2 fw-600'>Cancel</span>
                      </button>
                    </>
                    :
                    <>
                      <button className='SaveBtn align-items-center' onClick={UpdateTicketCall}>
                        <span className='pt-2 fw-600'>Update Ticket</span>
                        <img src='/images/DoneIcon.svg' className='img-fluid' style={{ height: '25px' }} />
                      </button>
                      <button className={`Cancel-btn ms-2`} onClick={(e) => !copyaccesstype && AdminMenuAccessFlag ? navigate('/school-tickets') : navigate('/manage-tickets')}>
                        <span className='pt-2 fw-600'>Cancel</span>
                      </button>
                    </>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      {DevicePopup == true && (
        <DeviceDetailsPopup Showbuttons={1} createticketbutton={false} deviceid={AllData?.DeviceID} activetab="device" isShow={DevicePopup} ClosePopup={(e) => setDevicePopup(false)} />
      )}

      {UserPopup == true && (
        <UserDetailsPopup isShow={UserPopup} ClosePopup={(e) => setUserPopup(false)} userid={DeviceDetails?.student?.id} />
      )}

      <Popup isshow={PreviewImage} size={"md"} title={"Preview Image"}
        closePopup={(e) => setPreviewImage(false)}
        modalBody={<img className="img-fluid" src={ModelImage} alt="" />} visibleSaveBtn={false} />

      <AlertPopup isshow={IsBuildingChangeModal} img={'/images/greenInfo.svg'}
        headingtext={`Make this location this device's primary building?`} text={''}
        cancelcall={(e) => { setIsBuildingChangeModal(false); setPrimaryLocation(2); }}
        canceltext={"No"} successtext={"Yes"} successcall={(e) => { setIsBuildingChangeModal(false); setPrimaryLocation(1) }} btntype={'SaveBtn'} />

      {IsAlreadyTicketModal == true && (
        <Popup isshow={IsAlreadyTicketModal} size={"md"} title={"Ticket Management"}
          closePopup={(e) => {
            setDefaultImage(true); setIsAlreadyTicketModal(false);
            setAllData((prevData) => ({
              ...prevData,
              TicketId: "",
              SchoolId: "",
              DeviceID: "",
              TicketNum: "",
              TicketStatus: "",
              BuildingId: "",
              IsTicketCreated: 0
            }));
            setAlreadyTicketFlag(3);
          }}
          modalBody={ticketmodalbody} modalfooter={modalfooter} />
      )}

      {showReworkPopup == true && (
        <Popup isshow={showReworkPopup} size={"md"} title={"Select the ticket you would like to rework."}
          hideCloseButton={true} modalBody={ReworkModalBody} visibleSaveBtn={true} btnText={"Mark as Rework"}
          handleSave={handleMarkRework} hideCancelBtn={true} extraBtn={true} btntype={false} ExtraText="Not a Rework" handleSaveForExtra={handleNoRework} />
      )}
      <ImagesPopup
        AllImages={Images.map(item => item.img)}
        isShow={showImagesModal.show}
        closePopup={() => setShowImagesModal({ ...showImagesModal, show: false, activeIndex: 0, zoomInOut: false })}
        title={"Preview Images"}
        size={"xl"}
        activeIndex={showImagesModal.activeIndex}
        handleActiveIndex={(selectedIndex) => setShowImagesModal((prev) => ({ ...prev, activeIndex: selectedIndex, zoomInOut: false }))}
        zoomInOut={showImagesModal.zoomInOut}
        handleZoomInOut={() => setShowImagesModal({ ...showImagesModal, zoomInOut: !showImagesModal.zoomInOut })}
      />
    </Fragment>
  )
}
